<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
  <g fill="none" fill-rule="evenodd">
    <g>
      <g>
        <g>
          <path d="M0 0H30V30H0z" transform="translate(-32 -649) translate(32 648) translate(0 1)"/>
          <path fill="#FFF" d="M7.362 27.64c-.87.625-2.025.688-2.959.162-.934-.526-1.478-1.546-1.395-2.614V3.969c-.083-1.068.461-2.088 1.395-2.614.934-.526 2.088-.463 2.96.162L24.97 12.18c.92.472 1.499 1.419 1.499 2.453 0 1.034-.579 1.98-1.5 2.452L7.363 27.64z" transform="translate(-32 -649) translate(32 648) translate(0 1)"/>
        </g>
      </g>
    </g>
  </g>
</svg>
